// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import Vue from 'vue'
import App from './App'
import store from './store/index'
import router from './router/premission'

// import Echarts from 'echarts'
import 'vue-area-linkage/dist/index.css'
import VueAreaLinkage from 'vue-area-linkage'
import global from './global_variable'
import service from '@/utils/http-service'
import Mamchargeui from 'vue-mamcharge-ui'
import '@/styles/icon-menu/iconfont.css'
import '@/styles/element-variables.scss'
import '@/styles/base.css'
import '@/styles/public.css'
import '@/styles/transition.scss'
import '@/styles/element-cover.scss'
import * as filters from '@/filters'
import VueDND from 'awe-dnd'
import VueCropper from 'vue-cropper' // 图片裁剪
import './utils/directives'
import VueClipboard from 'vue-clipboard2'
import './utils/fixed'
// 按钮权限功能全局引入
import has from './utils/limit.js'
Vue.use(has)

Vue.config.devtools = true
// import { getUserName } from './api/login'
// import config from '@/utils/config'

// Vue.config.devtools = true;
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(VueCropper)
Vue.use(VueDND)
Vue.prototype.$http = service
Vue.prototype.$store = store
Vue.prototype.global = global
Vue.config.productionTip = false
Vue.use(VueAreaLinkage)
Vue.use(Mamchargeui)

// 单点登录 根据token 获取用户信息
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js